import { MainLayout } from "../../layout/MainLayout";
import { useSelectedNetworkImportTypes } from "../../hooks/useSelectedNetworkImportType";
import { UserInviteByName } from "../../components/UserInviteByName";
import { UserInviteByLink } from "../../components/UserInviteByLink";

export const UsersInvitePage = () => {
  const { isAcc, isEntrata, isRmbg, isCbord, isRms, isKinetic, isEmail } = useSelectedNetworkImportTypes();
  const isInviteByName = isAcc || isEntrata || isRmbg || isKinetic || isCbord || isRms || isEmail;

  return (
    <MainLayout title="Invite Users">
      {isInviteByName && <UserInviteByName />}
      {!isInviteByName && <UserInviteByLink />}
    </MainLayout>
  );
};
